import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { InitializationService } from '../../../services/initialization.service';
import { UsuarioService } from '../../../services/usuario.service';

declare var $: any;

@Component({
    selector: 'app-guia',
    templateUrl: './guia.component.html',
    styleUrls: ['./guia.component.css'],
    providers: [UsuarioService],
})
export class GuiaComponent {
    @ViewChild('paso_a_paso', { static: true })
    paso_a_paso: ModalDirective;

    constructor(
        public translateService: TranslateService,
        private _config: InitializationService,
        private usuarioService: UsuarioService
    ) {}

    pasos = [];
    firstTime = false;
    noMore = false;
    msgs = '';

    async ngAfterViewInit() {
        await this.getNoQuieroBienvenida();
    }

    async set_guia() {
        this.noMore = false;
        let root = 'ayuda.simbologia.simbolos';

        let fg = await this.translateService
            .get(
                [
                    `${root}.navegacion.nombre`,
                    `${root}.portal.nombre`,
                    `${root}.novedades.nombre`,
                    `${root}.avisos.nombre`,
                    `${root}.modulos_apps.nombre`,
                    `${root}.ayuda.subs.contacto.nombre`,
                    `${root}.usuario.nombre`,

                    `ayuda.tutorial.navegacion`,
                    `ayuda.tutorial.portal`,
                    `ayuda.tutorial.mis_aplicaciones`,
                    `ayuda.tutorial.usuario`,
                    `ayuda.tutorial.avisos_noticias`,
                    `ayuda.tutorial.contacto`,
                    `ayuda.tutorial.glosa`,
                ],
                {
                    val1: this._config.getIcon('navegacion'),
                    val2: this._config.getIcon('goback_portal'),
                    val3: this._config.getIcon('modulos_aplicaciones'),
                    val4: this._config.getIcon('micuenta'),
                    val5: this._config.getIcon('correouv'),
                    val6: this._config.getIcon('cambiaclave'),
                    val7: this._config.getIcon('logout'),
                    val8: this._config.getIcon('noticias'),
                    val9: this._config.getIcon('avisos'),
                    val10: this._config.getIcon('ayuda'),
                    val11: this._config.getIcon('contacto'),
                    val12: this._config.getIcon('ayuda'),
                    val13: this._config.getIcon('tutorial'),
                }
            )
            .toPromise();

        this.msgs = `${fg['ayuda.tutorial.glosa']}`;

        this.pasos = [
            {
                src: 'https://repositorio.uv.cl/videos/template/guia/menus.mp4',
                title: `${fg[`${root}.navegacion.nombre`]}`,
                texto: `${fg['ayuda.tutorial.navegacion']}`,
            },
            {
                src:
                    'https://repositorio.uv.cl/videos/template/guia/volver_portal.mp4',
                title: `${fg[`${root}.portal.nombre`]}`,
                texto: `${fg['ayuda.tutorial.portal']}`,
            },
            {
                src:
                    'https://repositorio.uv.cl/videos/template/guia/avisos_noticias.mp4',
                title: `${fg[`${root}.avisos.nombre`]} - ${
                    fg[`${root}.novedades.nombre`]
                }`,
                texto: `${fg['ayuda.tutorial.avisos_noticias']}`,
            },
            {
                src:
                    'https://repositorio.uv.cl/videos/template/guia/contacto.mp4',
                title: `${fg[`${root}.ayuda.subs.contacto.nombre`]}`,
                texto: `${fg['ayuda.tutorial.contacto']}`,
            },
            {
                src:
                    'https://repositorio.uv.cl/videos/template/guia/modulos_aplicaciones.mp4',
                title: `${fg[`${root}.modulos_apps.nombre`]}`,
                texto: `${fg['ayuda.tutorial.mis_aplicaciones']}`,
            },
            {
                src:
                    'https://repositorio.uv.cl/videos/template/guia/usuario.mp4',
                title: `${fg[`${root}.usuario.nombre`]}`,
                texto: `${fg['ayuda.tutorial.usuario']}`,
            },
        ];

        this.paso_a_paso.show();
    }

    controlVideo(event, start) {
        let video = $(`#${event.index}`).get(0);
        if (start) {
            video.currentTime = 0;
            video.play();
        } else {
            video.pause();
        }
    }

    async getNoQuieroBienvenida() {
        this.noMore = false;
        this.firstTime = false;

        if (this._config.get('SISTEMA.TUTORIAL.ACTIVE')) {
            let user = JSON.parse(window.sessionStorage.getItem('user'));
            let response = await this.usuarioService.getNoQuieroBienvenida(
                user.uid
            );
            this.firstTime = response == null;

            if (this.firstTime) this.set_guia();
        }
    }

    async close() {
        if (this.firstTime && this.noMore) {
            let user = JSON.parse(window.sessionStorage.getItem('user'));
            await this.usuarioService.addNoQuieroBienvenida(user.uid, {
                welcome: false,
            });
            this.firstTime = false;
        }
        this.paso_a_paso.hide();
    }
}
